export default {
  visitorsAgreement: {
    url: '/legal/visitor-agreement.xhtml',
    text: 'and '
  },
  privacyStatement: {
    href: '/legal/privacy-statement.xhtml',
    text: 'By subscribing, you agree to our',
    label: 'Privacy Statement'
  },
  message: 'Receive price alerts and new results for this search.',
  createAccount: 'to save, manage, view recent searches and get more alert options. ',
  confirmation: {
    alert: 'We\'ll send you an email when there are new matches for this search.',
    signUp: 'Create an account to easily save more searches and manage alerts across devices.',
    toast: 'You\'re all set to receive price alerts and new results for this search.'
  },
  title: 'Save Search',
  inline: {
    title: 'You\'ve signed up for a new alert',
    message: 'Email me price alerts & new results for this search.',
    confirmation: {
      signUp: 'to save, manage, view recent searches and get more alert options.',
      alert: 'We\'ll send you an email when new matches arrive for your saved search.'
    },
    privacyStatement: {
      text: 'By subscribing, you agree to our'
    }
  },
  bestDeals: {
    title: 'You\'ve signed up for Best Deals',
    confirmation: {
      alert: 'You\'ll start receiving Best Deals emails.',
      signUp: ['You can also', 'to save cars you like or your favorite searches.']
    }
  },
  toast: {
    title: 'Success!',
    type: 'confirm',
    swipeDirection: {
      mobile: 'down',
      desktop: 'up'
    },
    successMessage: {
      firstPart: 'You\'re all set to receive price alerts',
      secondPart: 'and new results for this search.'
    }
  }
};